export const PROFILE_EMPLOYER_UPDATE_REQUEST = 'profile/employer-update-request'
export const PROFILE_EMPLOYER_UPDATE_SUCCESS = 'profile/employer-update-success'
export const PROFILE_EMPLOYER_UPDATE_FAILED = 'profile/employer-update-failed'
